module.exports = __webpack_public_path__ + "img/barcode-read.2e006a27.svg";